import React from 'react';

const IndustryIcons = ({ from }) => {
  const industries = [
    {
      name: "Restaurant",
      icon: (
        <svg className="w-12 h-12" fill="currentColor" viewBox="0 0 24 24">
          <path d="M11 9H9V2H7v7H5V2H3v7c0 2.12 1.66 3.84 3.75 3.97V22h2.5v-9.03C11.34 12.84 13 11.12 13 9V2h-2v7zm5-3v8h2.5v8H21V2c-2.76 0-5 2.24-5 4z"/>
        </svg>
      ),
      description: "Food & Beverage"
    },
    {
      name: "Retail",
      icon: (
        <svg className="w-12 h-12" fill="currentColor" viewBox="0 0 24 24">
          <path d="M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12L8.1 13h7.45c.75 0 1.41-.41 1.75-1.03L21.7 4H5.21l-.94-2H1zm16 16c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z"/>
        </svg>
      ),
      description: "Shopping"
    },
    {
      name: "Pharmacy",
      icon: (
        <svg className="w-12 h-12" fill="currentColor" viewBox="0 0 24 24">
          <path d="M6 3h12v2h-5v6.22c.55.55.9 1.33.9 2.18V20c0 .55-.45 1-1 1h-2c-.55 0-1-.45-1-1v-8.6c0-.85.35-1.63.9-2.18V5H6V3z"/>
        </svg>
      ),
      description: "Healthcare"
    },
    {
      name: "Salon",
      icon: (
        <svg className="w-12 h-12" fill="currentColor" viewBox="0 0 24 24">
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
        </svg>
      ),
      description: "Beauty"
    },
    {
      name: "Cafe",
      icon: (
        <svg className="w-12 h-12" fill="currentColor" viewBox="0 0 24 24">
          <path d="M20 3H4v10c0 2.21 1.79 4 4 4h6c2.21 0 4-1.79 4-4v-3h2c1.11 0 2-.9 2-2V5c0-1.11-.89-2-2-2zM20 8h-2V5h2v3zM4 19h16v2H4z"/>
        </svg>
      ),
      description: "Coffee Shop"
    },
    {
      name: "Electronics",
      icon: (
        <svg className="w-12 h-12" fill="currentColor" viewBox="0 0 24 24">
          <path d="M17 1.01L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z"/>
        </svg>
      ),
      description: "Tech Store"
    }
  ];

  // Different styles based on the 'from' prop
  const getStyles = () => {
    if (from === "mainFeature") {
      return {
        container: "py-12 bg-white overflow-hidden",
        title: "text-2xl font-bold text-center mb-3 text-gray-800",
        subtitle: "text-gray-600 text-center mb-8 max-w-xl mx-auto text-sm",
        card: "bg-gradient-to-br from-blue-50 to-indigo-50 p-6 rounded-xl shadow-md hover:shadow-lg transition-all duration-300 hover:scale-105 border border-blue-100 min-w-[180px]",
        icon: "text-indigo-600 mb-3 group-hover:scale-110 transition-transform duration-300",
        iconSize: "w-10 h-10",
        titleText: "font-semibold text-gray-800 mb-1 text-base",
        description: "text-xs text-gray-500",
        animation: "animate-scroll-left-fast",
        spacing: "mx-4"
      };
    } else {
      return {
        container: "py-16 bg-gradient-to-r from-blue-50 to-indigo-50 overflow-hidden",
        title: "text-3xl font-bold text-center mb-4 text-gray-800",
        subtitle: "text-gray-600 text-center mb-12 max-w-2xl mx-auto",
        card: "bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105 border border-gray-100 min-w-[200px]",
        icon: "text-blue-600 mb-4 group-hover:scale-110 transition-transform duration-300",
        iconSize: "w-12 h-12",
        titleText: "font-bold text-gray-800 mb-2 text-lg",
        description: "text-sm text-gray-500",
        animation: "animate-scroll-left",
        spacing: "mx-6"
      };
    }
  };

  const styles = getStyles();

  return (
    <div className={styles.container}>
      <div className="container mx-auto px-4">
        <h2 className={styles.title}>
          {from === "mainFeature" ? "Compatible Industries" : "Trusted by Industries Worldwide"}
        </h2>
        <p className={styles.subtitle}>
          {from === "mainFeature" 
            ? "Our solution works seamlessly across multiple industry verticals"
            : "Our POS solution is designed to work seamlessly across various industries, helping businesses of all types streamline their operations."
          }
        </p>
        
        {/* Scrolling Icons Container */}
        <div className="relative">
          <div className={`flex ${styles.animation} `}>
            {[...industries, ...industries].map((industry, index) => (
              <div
                key={index}
                className={`flex-shrink-0 ${styles.spacing} text-center group cursor-pointer`}
              >
                <div className={`${styles.card} flex flex-col items-center justify-center`}>
                  <div className={styles.icon}>
                    <div className={styles.iconSize}>
                      {industry.icon}
                    </div>
                  </div>
                  <h3 className={styles.titleText}>
                    {industry.name}
                  </h3>
                  <p className={styles.description}>
                    {industry.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default IndustryIcons;